module.exports = __webpack_public_path__ + "static/media/Logo_circle.f67e9fe7.png";